let mapBoxStylePath = 'https://m.24timezones.com/styles/osm-bright-' + jinjaVars.lang + '/style.json';
let mapBoxHybridStylePath = 'https://m.24timezones.com/styles/hybrid-' + jinjaVars.lang + '/style.json';
let mapBackgroundLang = jinjaVars.lang;

const CUSTOM_LANGS = ['da'];
const GCSE_RESULTS_URL = '/' + jinjaVars.lang + '/us-cities/gcse-search/' + jinjaVars.short_name_url;

if (CUSTOM_LANGS.includes(jinjaVars.lang)) {
    mapBoxStylePath = '/map/osm-bright-' + jinjaVars.lang + '/style.json';
    mapBoxHybridStylePath = '/map/hybrid-' + jinjaVars.lang + '/style.json';
    mapBackgroundLang = 'en';
}

function renderOpenStreetMap() {
    mapboxgl.accessToken = jinjaVars.mapbox_token;
    const mapbox_satellite_layer = jinjaVars.mapbox_satellite_layer;
    const map = new mapboxgl.Map({
        container: 'map',
        style: mapBoxStylePath,
        zoom: 10,
        center: [
            parseFloat(jinjaVars.longitude),
            parseFloat(jinjaVars.latitude)
        ],
        attributionControl: false,
        preserveDrawingBuffer: true
    });
    map.addControl(new mapboxgl.NavigationControl({showCompass: false}));
    map.addControl(new mapboxgl.FullscreenControl());

    const boundary_box = jinjaVars.boundary_box;
    if ('north' in boundary_box && 'west' in boundary_box && 'east' in boundary_box && 'south' in boundary_box) {
        map.fitBounds([
            [parseFloat(boundary_box['west']), parseFloat(boundary_box['south'])],
            [parseFloat(boundary_box['east']), parseFloat(boundary_box['north'])]
        ]);
    }

    map.on("load", () => {
        const cityPin = new mapboxgl.Marker();
        cityPin.setLngLat([
            parseFloat(jinjaVars.longitude),
            parseFloat(jinjaVars.latitude)
        ]);

        const ctrlFitWorldBounds = document.getElementById("ctrl-fit-world-bounds")
        if (ctrlFitWorldBounds) ctrlFitWorldBounds.addEventListener("click", e => {
            map.setZoom(2);
            setTimeout(function () {
                cityPin.addTo(map);
            }, 300);
            e.stopPropagation();
            e.preventDefault();
        });
    });

    map.addControl(new MapBoxGoogleCustomSearch({
        resultsUrl: '/' + jinjaVars.lang + '/cities2/gcse-search/' + jinjaVars.short_name_by_lang
    }), 'top-left');

    map.addControl(
        new MapBoxToPdfControl(
            jinjaVars.short_name,
            jinjaVars.save_to_pdf,
            jinjaVars.download_pdf
        ), 'top-left');

    map.addControl(new MapBoxDirectionsControl(
        jinjaVars.latitude + ', ' + jinjaVars.longitude,
        jinjaVars.directions
    ), 'top-left');

    var map_styles = [
        {
            id: 'street',
            title: jinjaVars.map,
            uri: mapBoxStylePath
        },
        {
            id: 'satellite',
            title: jinjaVars.satellite,
            uri: mapBoxHybridStylePath
        }
    ];
    var switcher_control = new MapBoxStyleSwitcherControl(map_styles, 'street');
    map.addControl(switcher_control);
}

if (mapboxgl.supported()) {
    renderOpenStreetMap();
} else {
    mapElement.style.backgroundImage = 'url(https://m.24timezones.com/styles/osm-bright-' + mapBackgroundLang + '/static/' + jinjaVars.longitude + jinjaVars.latitude + ',10/800x600.png)';
    mapElement.style.backgroundRepeat = 'no-repeat';
    mapElement.appendChild(document.getElementById("gmap-search-box"));

    const gcseSearchbox = document.createElement("gcse:searchbox-only");
    gcseSearchbox.adchannel = "9824253390";
    gcseSearchbox.lr = 'lang_' + jinjaVars.lang;
    gcseSearchbox.webSearchQueryAddition = jinjaVars.short_name;

    (function () {
        const cx = 'partner-pub-6183744382086490:4052689605';
        const gcse = document.createElement('script');
        gcse.type = 'text/javascript';
        gcse.async = true;
        gcse.src = 'https://cse.google.com/cse.js?cx=' + cx;
        const s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(gcse, s);
    })();
}

function initialize() {
    const boundary_box = jinjaVars.boundary_box;
    if ('north' in boundary_box && 'west' in boundary_box && 'east' in boundary_box && 'south' in boundary_box) {
        const bounds_obj = new google.maps.LatLngBounds(
            {'lat': parseFloat(boundary_box['south']), 'lng': parseFloat(boundary_box['west'])},
            {'lat': parseFloat(boundary_box['north']), 'lng': parseFloat(boundary_box['east'])}
        );
        const map = new google.maps.Map(document.getElementById("map"), {
            center: bounds_obj.getCenter(),
            gestureHandling: 'greedy',
            mapTypeControlOptions: {
                position: google.maps.ControlPosition.LEFT_BOTTOM
            },
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_CENTER
            }
        });
        map.fitBounds(bounds_obj);
    } else {
        const map = new google.maps.Map(document.getElementById("map"), {
            center: new google.maps.LatLng(
                parseFloat(jinjaVars.latitude),
                parseFloat(jinjaVars.longitude)
            ),
            zoom: 12,
            gestureHandling: 'greedy',
            mapTypeControlOptions: {
                position: google.maps.ControlPosition.LEFT_BOTTOM
            },
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_CENTER
            }
        });
    }

    const search_input = document.getElementById('pac-input');
    new InMapSearchInput(map, search_input, document.getElementById('info-window-content'));
    map.controls[google.maps.ControlPosition.TOP_LEFT].push(search_input);

    const centerControlDiv = document.createElement('div');
    new GMapToPdfControl(
        centerControlDiv, map, jinjaVars.lang, jinjaVars.short_name,
        jinjaVars.save_to_pdf, jinjaVars.download_pdf
    );
    centerControlDiv.index = 1;
    map.controls[google.maps.ControlPosition.LEFT_TOP].push(centerControlDiv);

    const directionsControlDiv = document.createElement('div');
    new DirectionsRedirectControl(directionsControlDiv, map,
        jinjaVars.latitude + ', ' + jinjaVars.longitude,
        jinjaVars.directions
    );
    directionsControlDiv.index = 2;
    map.controls[google.maps.ControlPosition.LEFT_TOP].push(directionsControlDiv);
}

const mapSearchLinks = document.querySelectorAll(".map-search-link");

for (const link of mapSearchLinks) {
    link.addEventListener("click", e => {
        const query = link.getAttribute("data-query");
        if (typeof dataLayer !== "undefined") dataLayer.push({event: "map-search", q: query});
        window.location.href = `${GCSE_RESULTS_URL}?q=${encodeURIComponent(query)}`;
        e.stopPropagation();
        e.preventDefault();
    });
}
